import { IListProps, List, ListItem, useCheckedCollection } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ReactNode } from 'react';
import Idable from 'types/Idable';
import CheckItem from './CheckItem/CheckItem';
import './CheckList.scss';

export interface ICheckListProps<T extends Idable<IdType>, IdType extends string | number> extends IListProps {
  readonly items: T[];
  readonly checkedItems: IdType[];
  renderItem: (item: T) => ReactNode;
  onCheck: (ids: IdType[]) => void;
  className?: string | object;
}

const CheckList = <T extends Idable<IdType>, IdType extends string | number>(props: ICheckListProps<T, IdType>) => {
  const { items, renderItem, onCheck, checkedItems, className, ...listProps } = props;

  const { onCheck: onEnhancedCheck } = useCheckedCollection(items, checkedItems, 'id', onCheck);

  function renderItems() {
    return items.map((item) => {
      function onItemCheck(isChecked: boolean) {
        onEnhancedCheck(item.id, isChecked);
      }

      return (
        <ListItem key={item.id}>
          <CheckItem
            className="pl-6"
            checked={checkedItems.some((checked) => checked === item.id)}
            onChange={onItemCheck}
          >
            {renderItem(item)}
          </CheckItem>
        </ListItem>
      );
    });
  }

  const classes = classNames(
    {
      'check-list': true,
    },
    className
  );

  return (
    <List className={classes} {...listProps}>
      {renderItems()}
    </List>
  );
};

CheckList.defaultProps = {
  stroke: true,
};

export default CheckList;
